module.exports = __webpack_public_path__ + "static/media/right.a68a6633.svg";